<template>
	<div class="body-mobile">
		<div class="wrapper-body">
			<div class="wrapper-body__header">
				<nav-step :active="3"></nav-step>
			</div>
			<div class="wrapper-body__body">
				<div class="wrapper-body__body__title">
					<p v-if="studentType == 1">填写信息<span>（3/5）</span></p>
					<p v-else>填写信息<span>（2/4）</span></p>
				</div>
				<div class="wrapper-body__body__container" v-if="form&&form.guardian">
					<template v-if="studentType == 1">
						<md-field>
							<md-field-item title="" solid>
								<md-radio :name="1" v-model="guardianType" label="监护人" inline />
								<md-radio :name="2" v-model="guardianType" label="委托监护人" inline />
							</md-field-item>
							<md-input-item
								v-model="form.guardian.name"
								title="监护人姓名"
								placeholder="请输入监护人姓名"
								:maxlength="40"
							></md-input-item>

							<!-- <md-field-item title="性别" solid v-if="guardianType == 1">
								<md-radio :name="0" v-model="form.guardian.sex" label="男" inline />
								<md-radio :name="1" v-model="form.guardian.sex" label="女" inline />
							</md-field-item> -->
							<md-input-item
								type="phone"
								title="手机号码"
								:maxlength="11"
								placeholder="请输入手机号码"
								v-model="form.guardian.mobile"
								clearable
							></md-input-item>

							<md-field-item
								title="民族"
								:placeholder="placeholderTextNation"
								arrow="arrow-right"
								:addon="form.guardian.nationName"
								@click="isNationPickerShow = true">
							</md-field-item>
							<md-picker
								ref="nationPicker"
								v-model="isNationPickerShow"
								:data="nationsData"
								@confirm="onNationPickerConfirm()"
								title="选择民族"
							></md-picker>

							<md-input-item
								v-model="form.guardian.companyName"
								title="工作单位"
								placeholder="请输入工作单位名称"
								:maxlength="80"
							></md-input-item>
							<template v-if="guardianType == 1">
								<md-field-item
									title="学历"
									:disabled="disabledEducation"
									:placeholder="placeholderTextEducation"
									arrow="arrow-right"
									:addon="form.guardian.education"
									@click="onClickEducation">
								</md-field-item>
								<md-picker
									v-model="isEducationPickerShow"
									ref="educationPicker"
									:data="educations"
									@confirm="onEducationPickerConfirm()"
									title="选择学历"
								></md-picker>
							</template>
							<div v-show="guardianType == 1">
							</div>

							<md-field-item
								title="户籍所在地"
								@click="isShowAddress = !isShowAddress"
								placeholder="请选择省市区"
								:content="addressValue"
								solid
							/>
								<!-- arrow="arrow-right" -->
							<md-tab-picker
								title="请选择"
								describe="请选择您所在的省份、城市、区县"
								:data="provinceData"
								:content="addressValue"
								v-model="isShowAddress"
								@change="handleChangeAddress"
							/>

							<!-- <md-input-item
								type="phone"
								title="户籍号"
								:maxlength="20"
								v-model="form.guardian.houseNumber"
								clearable
							></md-input-item> -->

							<md-input-item
								v-if="guardianType == 2"
								v-model="form.guardian.relationship"
								title="与幼儿关系"
								placeholder="请输入与幼儿关系"
								:maxlength="40"
							></md-input-item>

						</md-field>
					</template>

					<template v-else>
						<md-field>
							<md-input-item
								v-model="form.guardian.name"
								title="监护人姓名"
								placeholder="请输入监护人姓名"
								is-amount
								:maxlength="40"
							></md-input-item>

						<!--  <md-field-item title="性别" solid>
								<md-radio :name="0" v-model="form.guardian.sex" label="男" inline />
								<md-radio :name="1" v-model="form.guardian.sex" label="女" inline />
							</md-field-item>-->

							<md-input-item
								type="phone"
								title="手机号码"
								:maxlength="11"
								v-model="form.guardian.mobile"
								clearable
							></md-input-item>

							<md-input-item
								v-model="form.guardian.idCard"
								title="身份证号"
								placeholder="身份证号"
								clearable
							></md-input-item>

							<md-field-item
								title="证件类型"
								v-model="form.guardian.certificateType"
								:content="certificateTypeText"
								@click="showSelector"
								:disabled="form.student.applyType == 2"
								arrow
								solid
							/>
							<md-selector
								v-model="isSelectorShow"
								:data="certificateTypeList"
								title="证件类型"
								@choose="onSelectorChoose"
							>
								<template slot-scope="{ option }">
									<div class="md-selector-custom-brief">{{ option.text }}</div>
								</template>
							</md-selector>

							<md-field-item
								title="居住证所在地"
								@click="showAddress1 = !showAddress1"
								placeholder="请选择省市区"
								:content="pickerValue1"
								solid
							/>
								<!-- arrow="arrow-right" -->
							<!--<md-tab-picker
								title="请选择"
								describe="请选择您所在的省份、城市、区县"
								:data="provinceData"
								v-model="showAddress1"
								@change="handleChange"
							/>-->

							<!--<md-picker-->
								<!--ref="picker1"-->
								<!--title="请选择"-->
								<!--v-model="showAddress1"-->

								<!--:default-value="pickerDefaultValue"-->

								<!--:data="lqStreets"-->
								<!--:cols="2"-->
								<!--is-cascade-->
								<!--@confirm="onPickerConfirm(1)"-->
								<!--@change="handleChange"-->
							<!--&gt;</md-picker>-->
							<div class="clearfix">
								<md-field style="width:70%;float:right;">
									<md-field-item
										title=""
										arrow="arrow-right"
										@click="showAddress2 = !showAddress2"
										placeholder="请选择街道社区"
										:content="pickerValue2"
										solid
									/>
									<md-picker
										ref="picker2"
										title="请选择"
										v-model="showAddress2"

										:default-value="[]"

										:data="lqStreets"
										:cols="2"
										is-cascade
										@confirm="onPickerConfirm(2)"
										@change="handleChange"
									></md-picker>
								</md-field>
							</div>
							<!-- <md-input-item
								v-model="form.guardian.communityName"
								title="小区名字"
								placeholder="请输入小区名字"
								:maxlength="20"
							></md-input-item> -->

							<md-input-item
								v-model="form.guardian.address"
								title="详细地址"
								placeholder="小区名称或详细地址"
								:maxlength="50"
							></md-input-item>
							<font color="#f76700">提示：居住证地址或租赁备案凭证地址</font>
						</md-field>
					</template>

				</div>
			</div>
			<div class="wrapper-body__footer">
				<div class="box-btns">
					<span class="button-primary" @touchstart="handlePreviousStep">上一步</span>
					<span class="button-primary-inset"
						@touchstart="handleNextStep">下一步</span>
				</div>
				<!-- <div><router-link :to="{path: 'bm_login', query: {signupNoticeId: $route.query.signupNoticeId}}">同意并遵守</router-link></div> -->
			</div>
		</div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageForm from '../index/mixins/page_bm_form';
  import { Picker } from 'mand-mobile';

	import nationsData from './data/nations.json';
	import educations from './data/educations.json';
	import provinceData from './data/province.json';
  import config from '../../../config/index';

  export default {
    mixins: [IndexCommon, MobileCommon, PageForm],
    components: {
    	[Picker.name]: Picker
  	},
    data() {
      return {
				name: '',
				sex: '',
				phone: '',
				idCard: '',

				// 证件类型
				isSelectorShow: false,
        // 证件类型下拉列表
        certificateTypeList: [{ value: 1, text: '四川省居住证/成都市居住证' }, { value: 2, text: `成都市（除${config.web.areaName}外）户籍居民身份证` }],

				selectorValue: '',

				// 居住证所在地
        showAddress1: false,
        pickerValue1: `四川省成都市${config.web.areaName}`,
        pickerDefaultValue: [],

        // 街道社区
        showAddress2: false,
        pickerValue2: '',

				show: false,
				address: [],

        // 省市区列表
        provinces: [],
        // 龙泉街道
        lqStreets: [],

        // 街道列表
        streets: [],

        // 证件类型
				certificateTypeText: '',
				// 监护人类型
				guardianType: 1,
				// 监护人民族
				isNationPickerShow: false,
				nationsData,
				placeholderTextNation: '请选择',

				// 监护人学历
				disabledEducation: true,
				isEducationPickerShow: false,
				educations,
				placeholderTextEducation: '请选择',

				// 户籍所在地
				isShowAddress: false,
				addressValue: '',
				provinceData: provinceData, // 初始化占位
				// 户籍号
				houseNumber: '',
				guardianDomicileInfo: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				yearList: []
			}
		},

		computed: {
			addressStr() {
				return '';// this.address.map(item => item.label).join(' ')
			}
		},
		async mounted() {
      window.curStep = this.form;
			if (this.studentType == 1) {
				this.kinderMounted();
			} else {
				this.studentMounted();
			}
		},

		methods: {
			async kinderMounted() {
				// 1. 更新formData
				this.updateFormData();

				// this.form.guardian.guardianType = 2;
				let { data } = await this.getPcasCodeJson();
				if (data) {
					this.provinceData = data;
				}

				let { provinceName, cityName, areaName, guardianType, education, nationName } = this.form.guardian;

				if (provinceName && cityName && areaName) {
					this.addressValue = provinceName + cityName + areaName;
				}

				if (typeof guardianType !== 'undefined') {
					this.guardianType = guardianType;
				}

				if (nationName) {
					this.placeholderTextNation = '';
				}

				if (education) {
					this.placeholderTextEducation = ''
				}

				console.log('[-> Step3] Form ::', this.form);
				//  初始化时 学历选择框会触发点击事件 所以先禁用
				setTimeout(() => {
					this.disabledEducation = false;
				}, 300);
			},

			async studentMounted() {
				// window.step3 = this;
				// 1. 更新formData
				this.updateFormData();
				console.log('[-> Step3] Form ::', this.form);

				if (typeof this.form.guardian.certificateType !== 'undefined') { this.certificateTypeText = this.certificateTypeList[this.form.guardian.certificateType - 1].text; }

				// await this.getPcasCodeJson();
				await this.getLQStreetsJson();

				// 2. 转换formData中的某些字段到当前视图中
				// todo
				let form = this.form;
				// // 51 四川省 5101 成都市 510112 龙泉驿区

				// // 51 四川省 5101 成都市 510112 龙泉驿区
				form.guardian.provinceCode = '51';// values[0].code;
				form.guardian.provinceName = '四川省';// values[0].name;

				form.guardian.cityCode = '5101';// values[1].code;
				form.guardian.cityName = '成都市';// values[1].name;

				form.guardian.areaCode = this.areaId;// values[2].code;
				form.guardian.areaName = this.areaName;// values[2].name;

				form.areaCode = this.areaId;// values[0].code;
				form.areaName = this.areaName;// values[0].name;

				this.pickerDefaultValue = [];
				// this.$refs[`picker2`].refresh();
				this.pickerValue2 = [
					form.orderStreetName,
					form.guardian.villageName
				].join('');
				console.log(this.pickerValue2, 4444);

				if (this.form.student.applyType == 2) {
					this.form.guardian.certificateType = 1;
					this.certificateTypeText = this.certificateTypeList[0].text;
				}
				if (this.form.guardian.streetCode || this.form.orderStreetCode) {
					await this.getYearList()
				}
			},
      // 获取龙泉驿区的街道和社区信息
      async getLQStreetsJson() {
        let { data, error } = await this.$ajax.gateway('/bm/IAreaApi_queryAreas', {
					studentType: this.studentType,
          areaCode: config.web.areaId
        });
        console.log('龙泉街道-->', data, error);
        if (error) { return this.$message.error('获取龙泉街道失败！'); }
        this.lqStreets = [this.deepIn(data.data)];
        return data.data;
			},

			handleNextStep() {
				if (this.yearList.length < 1) {
					return this.$message.error('没有可以预约的日期');
				}
				if (this.studentType == 1) {
					this.kinderNext();
				} else {
					this.studentNext();
				}
			},

			kinderNext() {
				let { form, $message, guardianType } = this;
				//
				form.guardian.guardianType = guardianType;

        // 1.验证参数
				if (!form.guardian.name) return this.$message.error('监护人姓名不能为空！');

				if (guardianType == 1) {
					// if (typeof form.guardian.sex === 'undefined') {
					// 	return $message.error('监护人性别不能为空！');
					// }

					if (!form.guardian.education) {
						return $message.error('监护人学历不能为空！');
					}
				} else {
					if (!form.guardian.relationship) {
						return $message.error('与幼儿关系不能为空！');
					}

					if (!/^[\u4E00-\u9FA5]+$/.test(form.guardian.relationship)) {
						return $message.error('与幼儿关系只能输入中文！');
					}
				}

				if (!form.guardian.mobile) {
					return $message.error('手机号不能为空！');
				}

				if (!/(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/.test(form.guardian.mobile)) return this.$message.error('手机号格式错误！');

				if (typeof form.guardian.nationName === 'undefined') {
					return $message.error('监护人民族不能为空！');
				}

				if ((typeof form.guardian.companyName === 'undefined') || form.guardian.companyName === '') {
					return $message.error('工作单位不能为空！');
				}

				if (!form.guardian.provinceName || !form.guardian.cityName || !form.guardian.areaName) {
					return $message.error('户籍所在地不能为空！');
				}

				// if (typeof form.guardian.houseNumber === 'undefined') {
				// 	return $message.error('户籍号不能为空！');
				// }

        // 2.转换formData格式，使数据格式和后端的保持一致（需要的才处理）
        // form[xxx] = xxx;

        // 3.保存formData到sessionStorage中
        this.saveFormData(form);

        // 4.跳转路由
				this.$router.push({
					path: './step4_kinder',
					query: this.$route.query
				});
			},

			studentNext() {
        let { form, $message } = this;

        // 1.验证参数
        if (!form.guardian.name) return this.$message.error('监护人姓名不能为空！');
        // if (!/^[\u4E00-\u9FA5]{2,10}$/.test(form.guardian.name)) return this.$message.error('姓名格式错误！');
        // if(typeof form.guardian.sex === "undefined") return this.$message.error('性别 不能为空！');
        if (!form.guardian.mobile) return this.$message.error('联系方式 不能为空！');
        if (!/(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/.test(form.guardian.mobile)) return this.$message.error('联系方式 格式错误！');
        if (!form.guardian.idCard) return this.$message.error('身份证号 不能为空！');
        if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(form.guardian.idCard)) return this.$message.error('身份证号码格式错误！');
        if (!form.guardian.certificateType) return this.$message.error('证件类型 不能为空！');

        // todo 验证居住地字段并且转成formData格式
        if (!this.pickerValue1) return this.$message.error('居住地址 不能为空！');
				if (!this.pickerValue2) return this.$message.error('居住地址的街道社区 不能为空！');
				// if(!form.guardian.communityName) return this.$message.error('小区名字不能为空');
				if (!form.guardian.address) return this.$message.error('详细地址不能为空！');
        if (!/^[\u4E00-\u9FA5|\w]+$/.test(form.guardian.address)) return this.$message.error('详细地址请输入汉字、字母或数字');

        // 2.转换formData格式，使数据格式和后端的保持一致（需要的才处理）
        // form[xxx] = xxx;

				// 3.保存formData到sessionStorage中
				console.log(form, 6666)
        this.saveFormData(form);

        // 4.跳转路由
				this.$router.push({
					path: './step4_certify',
					query: this.$route.query
				});
			},
			// 证件类型
			showSelector() {
				this.isSelectorShow = true
			},
			onSelectorChoose({ text, value }) {
				this.selectorValue = text;
				this.certificateTypeText = text;
				this.form.guardian.certificateType = value;
				console.log(text, value, this);
			},

			handleChangeAddress({ options }) {
				this.addressValue = options.map(v => v.label).join('');
				console.log('户籍所在地 -------- ', options);
				this.form.guardian.provinceName = options[0] ? options[0].name : '';
				this.form.guardian.provinceCode = options[0] ? options[0].value : '';
				this.form.guardian.cityName = options[1] ? options[1].name : '';
				this.form.guardian.cityCode = options[1] ? options[1].value : '';
				this.form.guardian.areaName = options[2] ? options[2].name : '';
				this.form.guardian.areaCode = options[2] ? options[2].value : '';
			},

			// 民族
			onNationPickerConfirm() {
				const values = this.$refs['nationPicker'].getColumnValues()
				console.log('-> 选择民族', values);

				let value = values[0];

				this.placeholderTextNation = '';
				this.form.guardian.nationName = value.text;
			},

			onClickEducation() {
				console.log('hello', arguments);
				this.isEducationPickerShow = true;
			},

			// 学历
			onEducationPickerConfirm() {
				const values = this.$refs['educationPicker'].getColumnValues()
				console.log('-> 选择民族', values);

				let value = values[0];

				this.placeholderTextEducation = '';
				this.form.guardian.education = value.text;
			},

      // 居住证所在地
      onPickerConfirm(index) {
			  const compt = this.$refs[`picker${index}`];
        const values = compt.getColumnValues();

        let res = '';
        values.forEach(value => {
          value && (res += `${value.text || value.label} `)
        });
        console.log(values, '确认街道、社区');
				this[`pickerValue${index}`] = res;

				console.log('更改预约时间');
				if (values[0] && this.form.guardian.streetCode != values[0].code) {
					sessionStorage.setItem('form_orderDate', '');
					this.form.signupQuotaId = '';
				}

        let form = this.form;

      // // 51 四川省 5101 成都市 510112 龙泉驿区
        form.guardian.provinceCode = '51';// values[0].code;
        form.guardian.provinceName = '四川省';// values[0].name;

        form.guardian.cityCode = '5101';// values[1].code;
        form.guardian.cityName = '成都市';// values[1].name;

        form.guardian.areaCode = this.areaId;// values[2].code;
        form.guardian.areaName = this.areaName;// values[2].name;

        form.guardian.streetCode = values[0].code;// values[3].code;
        form.guardian.streetName = values[0].name;// values[3].name;

        form.orderStreetCode = values[0].code;
        form.orderStreetName = values[0].name;

        form.guardian.villageCode = values[1] ? values[1].code : '';
        form.guardian.villageName = values[1] ? values[1].name : '';

        form.areaCode = this.areaId;// values[0].code;
        form.areaName = this.areaName;// values[0].name;

        // 居住所在地
        if (index === 1111) {
		  // // 51 四川省 5101 成都市 510112 龙泉驿区
          form.guardian.provinceCode = '51';// values[0].code;
          form.guardian.provinceName = '四川省';// values[0].name;

          form.guardian.cityCode = '5101';// values[1].code;
          form.guardian.cityName = '成都市';// values[1].name;

          form.guardian.areaCode = this.areaId;// values[2].code;
          form.guardian.areaName = this.areaName;// values[2].name;

          form.guardian.streetCode = values[0].code;// values[3].code;
          form.guardian.streetName = values[0].name;// values[3].name;

          form.orderStreetCode = values[0].code;
          form.orderStreetName = values[0].name;

          form.guardian.villageCode = values[1] ? values[1].code : '';
          form.guardian.villageName = values[1] ? values[1].name : '';

          form.areaCode = values[0].code;
          form.areaName = values[0].name;

          /* if(values[2].code==='510112'){
            console.log('龙泉。。。');
            this.streets=this.deepIn([{"code":"510112001","name":"龙泉街道","children":[{"code":"2019001","name":"滨河花园社区"},{"code":"2019002","name":"商业街社区"},{"code":"2019003","name":"长柏路社区"},{"code":"2019004","name":"百工堰社区"},{"code":"2019005","name":"公园路社区"},{"code":"2019006","name":"广场社区"},{"code":"2019007","name":"万源路社区"},{"code":"2019008","name":"平江路社区"},{"code":"2019009","name":"明江路社区"},{"code":"2019010","name":"星光社区"},{"code":"2019011","name":"芦溪河社区"},{"code":"2019012","name":"红咏社区"},{"code":"2019013","name":"驿河社区"},{"code":"2019014","name":"聚和社区"},{"code":"2019015","name":"顶佛寺村"},{"code":"2019016","name":"平安村"},{"code":"2019017","name":"崇德社区"},{"code":"2019018","name":"龙都社区"},{"code":"2019019","name":"驿都路社区"},{"code":"2019020","name":"接龙社区"},{"code":"2019021","name":"界牌社区"},{"code":"2019022","name":"北泉路社区"},{"code":"2019023","name":"书房村"},{"code":"2019024","name":"书南社区"},{"code":"2019025","name":"怡新社区"},{"code":"2019026","name":"利民社区"},{"code":"2019027","name":"保平社区"},{"code":"2019028","name":"龙平社区"},{"code":"2019029","name":"保安社区"},{"code":"2019030","name":"魏家街社区"},{"code":"2019031","name":"合龙社区"}]},{"code":"510112002","name":"大面街道","children":[{"code":"2019101","name":"龙锦苑社区"},{"code":"2019102","name":"民乐社区"},{"code":"2019103","name":"五星社区"},{"code":"2019104","name":"天鹅湖村"},{"code":"2019105","name":"青台山村"},{"code":"2019106","name":"蒲草村"},{"code":"2019107","name":"龙华社区"},{"code":"2019108","name":"龙安社区"},{"code":"2019109","name":"洪河村"},{"code":"2019110","name":"师大社区"},{"code":"2019111","name":"陵川社区"},{"code":"2019112","name":"洪柳社区"},{"code":"2019113","name":"好日子社区"},{"code":"2019114","name":"东洪社区"},{"code":"2019115","name":"玉石社区"},{"code":"2019116","name":"分水村"}]},{"code":"510112003","name":"十陵街道","children":[{"code":"2019401","name":"天兴社区"},{"code":"2019402","name":"华川社区"},{"code":"2019403","name":"江华社区"},{"code":"2019404","name":"宁江社区"},{"code":"2019405","name":"石灵社区"},{"code":"2019406","name":"大梁村"},{"code":"2019407","name":"青龙村"},{"code":"2019408","name":"千弓村"},{"code":"2019409","name":"太平村"},{"code":"2019410","name":"来龙村"},{"code":"2019411","name":"友谊社区"},{"code":"2019412","name":"和平社区"},{"code":"2019413","name":"双龙社区"}]},{"code":"510112004","name":"同安街道","children":[]},{"code":"510112109","name":"柏合镇","children":[]},{"code":"510112102","name":"洛带镇","children":[]},{"code":"510112104","name":"西河镇","children":[{"code":"2019201","name":"滨西社区"},{"code":"2019202","name":"上游社区"},{"code":"2019203","name":"卫星村"},{"code":"2019204","name":"两河村"},{"code":"2019205","name":"跃进社区"},{"code":"2019206","name":"东风村"},{"code":"2019207","name":"龙井村"},{"code":"2019208","name":"鹿角社区"},{"code":"2019209","name":"黄连村"},{"code":"2019210","name":"大龙村"},{"code":"2019211","name":"阙家村"},{"code":"2019212","name":"天平村"}]},{"code":"510112111","name":"黄土镇","children":[]},{"code":"510112108","name":"洪安镇","children":[]},{"code":"510112115","name":"山泉镇","children":[]},{"code":"510112110","name":"茶店镇","children":[]},{"code":"510112200","name":"万兴乡","children":[]}]);
          }else{
            this.streets=compt.getColumnValue(2).children;
          }
          console.log(this.streets,888); */
        }

        if (index === 2222) {
          form.guardian.streetName = values[0].name;
          form.guardian.streetCode = values[0].code;
          form.guardian.villageCode = values[1].name;
          form.guardian.villageName = values[1].code;

          form.orderStreetCode = values[0].code;
          form.orderStreetName = values[0].name;
				}
				this.getYearList()
      },
			handleChange({ options }) {
				this.address = options
			},
			/**
       * 获取年月日列表，并存入yearList，依赖监护人的街道码
       * @requires this.submitData.guardian.streetCode
       */
      async getYearList() {

        // 某个区域该次报名的所有可预约的年月日列表（用户填报界面调用） #吴昂/2020-04-14#
        let {data,error} = await this.$ajax.gateway("/bm/ISignupQuotaApi_areaDate", {
            "METHOD": "get",
            "areaCode": this.form.guardian.streetCode || this.form.orderStreetCode,
            "signupNoticeId": this.$route.query.signupNoticeId
        });
        if (error) return;
        this.yearList = data.data;
      },
      // 获取省市区街道信息，并赋值给provinces

      deepIn(list) {
        for (let item of list) {
          item.label = item.name;
          item.value = item.code;
          // item.options = item.children;
          if (item.children && item.children.length > 0) {
            this.deepIn(item.children);
          }
        }
        return list;
      }

		}
  }
</script>

<style lang="stylus" scoped>

</style>
